import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

interface MobilePriceCardProps {
  id: string;
  name: string;
  price: string;
  period: string;
  features: string[];
  recommended?: boolean;
  disabled?: boolean;
  statusLabel?: string;
}

export function MobilePriceCard({ 
  id, 
  name, 
  price, 
  period, 
  features, 
  recommended,
  disabled,
  statusLabel
}: MobilePriceCardProps) {
  return (
    <Card className={`w-[260px] flex-shrink-0 p-4 relative ${
      recommended ? 'border-primary ring-2 ring-primary' : ''
    } ${disabled ? 'opacity-60' : ''}`}>
      {recommended && (
        <div className="bg-primary text-primary-foreground text-xs font-semibold px-2 py-0.5 rounded-full inline-block mb-2">
          Empfohlen
        </div>
      )}
      {disabled && statusLabel && (
        <div className="absolute top-2 right-2 bg-orange-500 text-white px-2 py-0.5 rounded-md text-xs font-bold">
          {statusLabel}
        </div>
      )}
      
      <h3 className="text-lg font-bold mb-0.5">{name}</h3>
      <div className="mb-3">
        <span className="text-2xl font-bold text-primary">{price}</span>
        <span className="text-xs text-muted-foreground ml-1">{period}</span>
      </div>
      
      <ul className="space-y-1.5 mb-4">
        {features.slice(0, 4).map((feature, idx) => (
          <li key={idx} className="flex items-start gap-1.5 text-xs">
            <Check className="w-3 h-3 text-primary flex-shrink-0 mt-0.5" />
            <span className="text-muted-foreground">{feature}</span>
          </li>
        ))}
      </ul>
      
      <Button
        variant={recommended ? "primary" : "outline"}
        className="w-full touch-target text-sm"
        size="sm"
        disabled={disabled}
        asChild={!disabled}
      >
        {disabled ? (
          <span>Bald verfügbar</span>
        ) : (
          <Link to="/speisekarte-hochladen">
            Auswählen
          </Link>
        )}
      </Button>
    </Card>
  );
}
